import { styled } from 'styled-components';

export const StyledLoaderWrap = styled.div`
  display: flex;
  justify-content: center;
`;
